import {applyCommands,createDocument,evaluateDataset,makeColumn,readDocument,serializeDocument,type Command} from '@akyo/science-core/document';
import type {GraphyoActivityConfig} from './graphyo-activity';

export const densityConcentrations=Array.from({length:12},(_,i)=>(i+1)*10);
export type ClassDensityValues=Record<string,number>;
export type ClassDensityChange={concentration:number;value:number;expected:number|null};
export function emptyDensityAnswer(config:GraphyoActivityConfig):string {
 let doc=createDocument('Masse volumique en fonction de la concentration',config.columns.map(c=>makeColumn(c.name,c.symbol,c.unit)));
 const data=doc.datasets[0];
 doc=applyCommands(doc,densityConcentrations.map((c,i)=>({type:'add-row',datasetId:data.id,rowId:'density-'+i})));
 doc=applyCommands(doc,[{type:'edit',datasetId:data.id,cells:densityConcentrations.map((c,i)=>({rowId:'density-'+i,columnId:data.columns[0].id,text:String(c)}))}]);
 const view=doc.views[0];
 doc=applyCommands(doc,[{type:'view',view:{...view,configuration:{
  x:{min:0,max:130,step:10},y:{min:980,max:1060,step:10},
  imposedFields:['title','x.quantity','x.symbol','x.unit','y.quantity','y.symbol','y.unit'],
  modeling:true,showEquation:true,showR2:true
 }}}]);
 return serializeDocument(doc);
}
export function densityValues(value:string):ClassDensityValues {
 if(!value)return {};
 const doc=readDocument(value),data=doc.datasets[0],cells=evaluateDataset(doc,data.id),values:ClassDensityValues={};
 for(const row of data.rows.filter(r=>!r.deleted)){
  const reading=cells.get(row.id)!,x=reading[data.columns[0].id],y=reading[data.columns[1].id];
  if(x.status==='missing'&&y.status==='missing')continue;
  if(x.status!=='number'||!densityConcentrations.includes(x.value))throw Error('Conserver les concentrations étalons de 10 à 120 g/L.');
  if(y.status==='missing')continue;
  if(y.status!=='number'||y.value<=0||y.value>2000)throw Error('Saisir une masse volumique numérique positive en g/L.');
  if(Object.hasOwn(values,String(x.value)))throw Error('Une seule mesure est attendue par concentration.');
  values[String(x.value)]=y.value;
 }
 return values;
}
/** Only touched measured cells are exchanged; graph constructions and calculations stay in the copy. */
export function densityChanges(value:string,baseline:ClassDensityValues):ClassDensityChange[] {
 return Object.entries(densityValues(value)).filter(([key,v])=>v!==baseline[key]).map(([key,v])=>({concentration:Number(key),value:v,expected:baseline[key]??null}));
}
export function mergeDensityValues(value:string,config:GraphyoActivityConfig,shared:ClassDensityValues):string {
 const doc=readDocument(value||emptyDensityAnswer(config)),data=doc.datasets[0],cells=evaluateDataset(doc,data.id);
 const edits:Extract<Command,{type:'edit'}>['cells']=[];
 for(const row of data.rows.filter(r=>!r.deleted)){
  const x=cells.get(row.id)![data.columns[0].id];
  if(x.status==='number'&&Object.hasOwn(shared,String(x.value)))edits.push({rowId:row.id,columnId:data.columns[1].id,text:String(shared[String(x.value)])});
 }
 return edits.length?serializeDocument(applyCommands(doc,[{type:'edit',datasetId:data.id,cells:edits}])):serializeDocument(doc);
}
